import { styled, Text } from '@grupoboticario/flora-react';

export default {
  Wrapper: styled('button', {
    alignItems: 'center',
    background: 'transparent',
    border: 'none',
    color: '$actionNavigationStandardStatic',
    display: 'inline-flex',
    padding: '$0',
    textDecoration: 'none',
  }),

  Icon: styled('div', {
    marginRight: '$2',
    position: 'relative',

    svg: {
      display: 'block',
      height: '16px',
      width: 'auto',
    },
  }),

  Label: styled(Text, {
    position: 'relative',
  }),
};
